import { IModalState, ModalActions, ModalTypes } from "../../consts/ModalTypes";

const initialState : IModalState = {
  open: false,
  notificacionStatus: {
    open: false,
    currDesc: "",
  },
};

export default function (state = initialState, action : ModalActions) : IModalState {
  switch (action.type) {
    case ModalTypes.HANDLE_MODAL:
      return { ...state, open: action.payload };
    case ModalTypes.GUARDAR_DATOS_CONTACTO:
      return { ...state, contactoPrestador: action.payload };
    case ModalTypes.HANDLE_MODAL_NOTIFICACION:
      return { ...state, notificacionStatus: action.payload };
    default:
      return { ...state };
  }
}
